module.exports = __webpack_public_path__ + "img/pdf-hover.6f9d148f.svg";